import { trim } from 'lodash';
import { type Location } from '.';
import { validateReportToContact } from "redux/ducks/CreateEvent/Shifts/validators";

// Validators
// -------------------------------

export const addErrorsToLocation = (location: Location) => {
  let messages = {};
  let contactMessages = {};

  if (!trim(location.name)) {
    messages.name = 'Venue Name is required';
  }
  if (!(location.id || location.placeId)) {
    messages.address = 'You must select a place from the list of results';
  }
  if (!trim(location.formattedAddress)) {
    messages.address = 'Address is required';
  }

  if (Number(location.countValue) < 1 || !location.countValue) {
    messages.countValue = 'This field is required';
  }

  if (!location.participantNumbersId) {
    messages.participantNumbersId = 'This field is required';
  }

  if (location.reportToContacts.length === 0) {
    contactMessages.emptyReportToContacts = 'You need at least one contact';
  }
  let reportToContactsErrors = [];
  let hasError = false;

  for (let i = 0; i < location.reportToContacts.length; ++i) {
    let error = validateReportToContact(location.reportToContacts[i]);
    reportToContactsErrors.push(error);
    if (Object.keys(error).length !== 0) {
      hasError = true;
    }
  }

  if (hasError) {
    contactMessages.reportToContacts = reportToContactsErrors;
  }

  return {
    ...location,
    errorMessages: messages,
    contactErrorMessages: contactMessages
  };
};
